import React from "react";

export default {
  "Chinese": "Chinese-Simplified",
  "English": "English",
  "Korean": "Korean",
  "WelcomenFoxitAdminConsole": "Welcome to the Foxit Admin Console",
  "FoxitPDFIntro": "Next generation PDF solutions for the world, with leading - edge technology that powers document intelligence, security, and collaboration services for PDF files.",
  "UserName": "User Name",
  "Password": "Password",
  "RememberMe": "Remember me",
  "password_between_prompt": "Passwords should contain 6-16 characters.",
  "password_required": "Password is required.",
  "confirmPassword_required": "Please confirm your password",
  "email_required": "Email address is required.",
  "email_error": "Please enter a valid email address.",
  "SignIn": "Sign In",
  "SignUp": "Sign Up",
  "AdminConsole": "Foxit Admin Console",
  "TenantsData": "Tenants data",
  "AdvancedSearch": "Advanced search",
  "PurchasedTime": "Purchased Time",
  "ExpiredTime": "Expired Time",
  "SearchCompanyName": "Search company name",
  "TotalCompany": "Total company:{{num}}",
  "CompanyName": "Company name",
  "Admin": "Admin",
  "PurchasedProducts": "Purchased Products",
  "WindowsPhantomPDFStandard": "Windows PhantomPDF Standard",
  "WindowsPhantomPDFBusiness": "Windows PhantomPDF Business",
  "FoxitSignUserModel": "Foxit Sign User Model",
  "FoxitSignEnvelopeModel": "Foxit sign Envelope Model",
  "All Products": "All Products",
  "AdminConsoleExplain": "The Foxit Admin Console is the portal IT administrators can use to manage user accounts and configuration settings for Foxit products and services, as well as an optional internal update server. You can use the Admin Console on Foxit Cloud or a local installation.",
  "MacPhantomPDF": "Mac PhantomPDF",
  "PhantomPDFOnline": "PhantomPDF Online",
  "All": "All",
  "Searchresult": "Search result({{num}})",
  "permanently effective": "permanently effective",
  "SearchFor": "search for {{user}}",
  "New features": "New features",
  "Resolved issues": "Resolved issues",
  "Accessible product":"Accessible product",
  "Submit": "Submit",
  "Permission Management": "Permission Management",
  "AdminManagement": "Admin Management",
  "RoleManagement": "Role Management",
  "Email": "Email",
  "CreateTime": "Create Time",
  "LastLoginTime": "Last Login Time",
  "LastLoginIP": "Last Login IP",
  "LastLoginIPArea": "Last Login IP Area",
  "LastLoginIPAreaCode": "Last Login IP Area Code",
  "Status": "Status",
  "Disabled": "Disabled",
  "Enabled": "Enabled",
  "Action": "Action",
  "SearchEmail": "Search Email",
  "AddAdmin":"Add Admin",
  "AddRole": "Add Role",
  "Description": "Description",
  "Name": "Name",
  "Delete": "Delete",
  "Edit": "Edit",
  "Add": "Add",
  "Roles": "Roles",
  "ConfirmDelete": "Confirm Delete",
  "DeleteTip": "Deleting this role will remove all associated permissions. This action cannot be undone.",
  "PermissionForThis": "You do not have permission for this.",
  "Yes": "Yes",
  "No": "No",
  "RoleSelection": "Role Selection",
  "PleaseSelectRole": "Please select at least one role",
  "RolesName": "Roles Name",
  "RoleDescription": "Role Description",
  "PleaseEnterEmail": "Please enter email",
  "EmailFormatError": "Email format error",
  "EditSuccess": "Edit success",
  "AddSuccess": "Add success",
  "PleaseEnterRolesName": "Please enter roles name",
  "PleaseEnterDescription": "Please enter description",
  "SelectAllAPIs": "Select All APIs",
  "SelectAllMenus": "Select All Menus",
  "SelectAll": "Select All",
  "ClearAll": "Clear All",
  "PermissionResources": "Permission Resources",
  "PleaseSelectPermissionResources": "Please select permission resources",
  "Menu": "Menu",
  "API": "API",
  "Strategy": "Strategy",
  "SelectStrategy": "Select strategy",
  "EnableSuccess": "Enable success",
  "EnableFailed": "Enable failed",
  "DisableSuccess": "Disable success",
  "DisableFailed": "Disable failed",
  "DeleteSuccess": "Delete success",
  "DeleteFailed": "Delete failed",
  "CreateSuccess": "Create success",
  "CreateFailed": "Create failed",
  "SSOLogin": "SSO Login",
  "ContentLogs": "Content Logs",
  "Operator": "Operator",
  "LoginIP": "Login IP",
  "LoginIPArea": "Login IP Area",
  "LoginIPAreaCode": "Login IP Area Code",
  "UpdateRegion": "Update Region",
  "Region": "Region",
  "Country": "Country",
  "UpdateRegionInfo": "Update Region Information",
  "UpdateCountry": "Update Country",
  "UpdateCountryInfo": "Update Country Information",
  "PleaseSelectRegion": "Please select region",
  "PleaseSelectCountry": "Please select country",
  "UpdateSuccess": "Updated successfully",
  "UpdateFailed": "Update failed",
  "FailedToLoadCountries": "Failed to load country list",
  "UserNotFound": "User not found",
  "FailedToGetUserInfo": "Failed to get user information",
  "PleaseEnterValidEmail": "Please enter a valid email and wait for user information to load",
  "multipleEmailAddresses": "To enter multiple email addresses, please enter one per line.",
  "EmailFormat": "Email format error: ",
  "SomeEmailsFailed": "Some emails failed to update region: ",
  "SuccessfulEmails": "Successful Emails ({{count}}): ",
  "FailedEmails": "Failed Emails ({{count}}): ",
  "SubmissionResults": "Submission Results",
  "None": "None",
  "1000lines": "You can only enter up to 1000 lines of email",
  "countryUnchanged": "No changes to the country option will be applied if the modified region remains unchanged.",
  "updateRegiontips1": "Note that if you need to modify a user's region, please first confirm the enterprise region they belong to. For example, if the enterprise region is set to US, then the user's region can only be changed to US.",
  "updateRegiontips2": "If you wish to change the enterprise region itself, you will need to create a new Admin Console in the desired instance. Please do not attempt to directly modify the region of the Super Admin account in order to change the enterprise region, as this action is not supported and may cause system issues.",
  "importantNotes": "Important Notes",
  "DeleteAll": "Delete All",
  "ConfirmDeleteAllUsers": "Are you sure you want to delete all users in the list?",
  "GetResourceListFailed": "Get resource list failed",
  "GetPolicyListFailed": "Get policy list failed",
  "AddLogs": "Add logs",
  "Published": "Published",
  "Failed": "Failed",
  "FailedTips": "Synchronization for the <b> {{region}} </b> has failed. Please synchronize manually.",
  "PublishedTips": "The release note has been updated successfully",
  "Retrying": "Synchronous Retry in Progress...",
  "UpdateContactInfoTechnicalSupport": "Technical Support",
  "UpdateContactInfoEditArea": "Contact Information",
  "UpdateContactInfoTechnicalSupportDescription": "For technical issues, account problems, etc.",
  "UpdateContactInfoSalesInquiries": "Sales Inquiries",
  "UpdateContactInfoSalesInquiriesDescription": "For purchases, quotes, partnerships.",
  "UpdateContactInfoAddRow": "+ Add",
  "UpdateContactInfoKey": "eg:Phone",
  "UpdateContactInfoValue": "eg：1234567890",
  "UpdateContactInfoPreview": "Preview",
  "UpdateContactInfoPreviewHint": "This is a preview in Admin Console. Changes only take effect after clicking Submit.",
  "UpdateContactInfoKeyValueRequired": "Key and Value are required",
  "UpdateContactInfoAddAtLeastOne": "Please add at least one contact information",
  "UpdateContactInfoSaveSuccess": "Saved successfully",
  "UpdateContactInfoSaveFailed": "Failed to save"
}